import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { getInvoices } from '../../redux/actions/bookings';
import paginate from '../../data/paginate';

import {
  Form,
  RouteWrapper,
  Section,
  HeadingSection,
  Content,
  StaggeredList,
  BookingItem,
  Notification,
  Loader,
  Box,
  IconButton,
  Pagination,
} from '../../components';

interface Props {
  isFetching: boolean;
  dispatch: Function;
}

interface State {
  bookings: Array<any>;
  page: number;
  search: string;
  error?: string;
}

class Route extends React.Component<Props, State> {
  state = {
    bookings: [],
    page: 0,
    search: '',
    error: undefined,
  };

  async handleSearch(search: string, page: number = this.state.page) {
    const response = await this.props.dispatch(getInvoices(page, search));
    if (response.error) {
      this.setState({ error: response.error, bookings: [] });
      return;
    }
    this.setState({
      page,
      search,
      bookings: response.data,
      error: undefined,
    });
  }

  render() {
    return (
      <RouteWrapper
        requireAuth
        requirePermission="MANAGE_BOOKINGS"
        title="Search by Invoice Number"
        loading={this.props.isFetching}
      >
        <HeadingSection
          title="Search By Invoice Number"
          controls={[
            <IconButton
              key="return"
              icon="undo"
              className="is-default is-pulled-right"
              handleClick={() => {
                this.props.dispatch(goBack());
              }}
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <Content>
            <Box>
              <Form
                type="search"
                fields={[{ name: 'search', type: 'text' }]}
                hasButton={false}
                handleSubmit={async ({ search }) => {
                  this.handleSearch(search);
                }}
              />
            </Box>
            {this.state.error !== undefined ? (
              <Notification type="danger">{this.state.error}</Notification>
            ) : this.state.bookings.length > 0 ? (
              <>
                <StaggeredList>
                  {this.state.bookings.map((booking) => (
                    <BookingItem
                      key={booking.id}
                      booking={booking}
                      link={`/bookings/${booking.id}`}
                      hideControls
                    />
                  ))}
                </StaggeredList>
                <div className="field">
                  <Pagination
                    page={this.state.page}
                    lastPage={
                      this.state.bookings.length <=
                      paginate.bookingRelations.MAX
                    }
                    handleUpdate={async (page) => {
                      this.handleSearch(this.state.search, page);
                    }}
                  />
                </div>
              </>
            ) : (
              this.state.search !== '' && (
                <Notification type="default">No bookings found</Notification>
              )
            )}
          </Content>
        </Section>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ bookings }) => ({
  isFetching: bookings.isFetching,
});

export default connect(mapStateToProps)(Route);
